import { NewsTile } from "../components/new_tile";
import "react-multi-carousel/lib/styles.css";
import NewsType from "../models/news_type";

import styles from "./styles/news.module.scss";

import ApparaStartImg from "../assets/news_images/apparastart.jpg";
import Strings from "../strings/strings";
import Medilink from "../assets/news_images/medilinkmidlands.jpg";
import UpsteerAsseco from "../assets/news_images/upsteerasseco.jpg";
import Inpho from "../assets/news_images/inpho.jpg";
import ItapaJesena from "../assets/news_images/itapajesena.jpg";
import MedilinkHive from "../assets/news_images/medilinkhive.jpg";
import RioWebSummit from "../assets/news_images/rio_web_summit.jpg";
import ProgramSlovensko from "../assets/news_images/programSlovensko.jpg";
import { CustomLink } from "../components/link";

export const NewsSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const Carousel = require("react-multi-carousel").default;

  const responsiveCarousel = {
    desktop: {
      breakpoint: { max: 3000, min: 1280 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1280, min: 800 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1,
    },
  };

  return (
    <>
      <div {...className}>
        <div className={styles.news} id="news">
          <div className={styles.content}>
            <div className={styles.title}>
              {Strings.newsTitleFirst}
              <span className={styles.blueTitleSection}>{Strings.newsTitleBlue}</span>
            </div>
            <div className={styles.images}></div>
          </div>
          <div className={styles.carousel}>
            <Carousel
              responsive={responsiveCarousel}
              infinite={true}
              keyBoardControl={true}
              removeArrowOnDeviceType={["tablet", "mobile"]}
              centerMode={true}
            >
              <NewsTile
                imagePath={ProgramSlovensko}
                text={Strings.EuFund}
                date={Strings.EuFundDate}
                newsType={NewsType.News}
                footer={CustomLink(
                  "https://drive.google.com/file/d/1H0UghyhOJxyDH0h8sDIrlNhkLuA45OyH/view?usp=drivesdk",
                  Strings.EuFundLink
                )}
              />
              <NewsTile
                imagePath={RioWebSummit}
                text={Strings.rioEvent}
                date={Strings.rioEventDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={MedilinkHive}
                text={Strings.medilinkHive}
                date={Strings.medilinkHiveDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={ItapaJesena}
                text={Strings.itapa}
                date={Strings.itapaDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={UpsteerAsseco}
                text={Strings.upsteerAsseco}
                date={Strings.upsteerAssecoDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={Inpho}
                text={Strings.inphoVenture}
                date={Strings.inphoVentureDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={Medilink}
                text={Strings.medilink}
                date={Strings.medilinkDate}
                newsType={NewsType.Event}
              />
              <NewsTile
                imagePath={ApparaStartImg}
                text={Strings.upsteer}
                date={Strings.upsteerDate}
                newsType={NewsType.Event}
              />
            </Carousel>
          </div>
        </div>
      </div>
    </>
  );
};
